import { useQuery, gql, type QueryResult, QueryHookOptions } from '@apollo/react-hooks';
import { getAsset } from '#/graphql/queries';
import type { GetAssetQuery } from '#/graphql/types';
import _ from 'lodash';

export const GET_ASSET = gql(getAsset);

const useAssetQuery = (id?: string, options?: QueryHookOptions) => {
  const query: QueryResult<GetAssetQuery> = useQuery(
    GET_ASSET,
    _.merge({ variables: { id }, fetchPolicy: 'cache-and-network' }, options || {}),
  );

  return query;
};

export default useAssetQuery;
